import { requestInterceptor } from './requestInterceptor';
import { responseInterceptor } from './responseInterceptor';

const applyInterceptors = axiosInstance => {
    axiosInstance.interceptors.request.use(requestInterceptor);
    axiosInstance.interceptors.response.use(responseInterceptor);
};

export default applyInterceptors;
